import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.91675 7H11.0834", stroke: "#2D2DF0", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgMinus;
